(() => {
  // Desktop-only: skip on touch devices
  const canClickZoom = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function createClickZoom(image, zoomRatio = 2) {
    let overlay = null;

    function openZoom(event) {
      if (overlay) return; // prevent duplicates

      const src = image.getAttribute('data-magnify-src') || image.currentSrc || image.src;

      // Create overlay
      overlay = document.createElement('div');
      overlay.className = 'image-magnify-full-size';
      overlay.style.backgroundImage = `url('${src}')`;

      image.parentElement.appendChild(overlay);
      updateZoom(event);

      overlay.addEventListener('mousemove', updateZoom);
      overlay.addEventListener('click', closeZoom);
    }

    function updateZoom(event) {
      const rect = overlay.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const xPercent = (x / rect.width) * 100;
      const yPercent = (y / rect.height) * 100;

      const renderedW = image.getBoundingClientRect().width;
      overlay.style.backgroundSize = `${renderedW * zoomRatio}px`;
      overlay.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
    }

    function closeZoom() {
      if (!overlay) return;
      overlay.removeEventListener('mousemove', updateZoom);
      overlay.removeEventListener('click', closeZoom);
      overlay.remove();
      overlay = null;
    }

    image.addEventListener('click', (e) => {
      if (!overlay) {
        openZoom(e);
      } else {
        closeZoom();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!canClickZoom) return;
    document.querySelectorAll('.product-zoom-image').forEach(img => createClickZoom(img, 2));
  });
})();
